export const en = {
  // Header
  header: {
    home: "Home",
    listen: "Listen",
    drive: "Drive",
    about: "About Us",
    schedule: "Schedule",
    podcasts: "Podcasts",
    contact: "Contact"
  },
  
  // Home Page
  home: {
    welcome: "Welcome to Rete Italia",
    subtitle: "The Italian voice in Australia. Music, culture and information 24/7.",
    liveRadio: "Live Radio",
    liveRadioDesc: "Listen to live radio streaming",
    liveVideo: "Live Video",
    liveVideoDesc: "Watch our programs on video",
    podcastTitle: "Podcasts",
    podcastDesc: "Listen anytime",
    everywhere: "Everywhere",
    everywhereDesc: "Available on all devices",
    audioStreaming: "Audio Streaming",
    videoStreaming: "Video Streaming",
    nowPlaying: "Now playing on Rete Italia",
    liveVideoLabel: "Rete Italia Video Streaming",
    ctaTitle: "Join the Rete Italia Community",
    ctaSubtitle: "Stay connected with Italian culture in Australia",
    contactUs: "Contact Us",
    explorePodcasts: "Explore Podcasts"
  },
  
  // About Page
  about: {
    title: "About Us",
    subtitle: "Australia's national Italian-language radio network, connecting communities through news, culture, and music.",
    storyTitle: "About Rete Italia",
    story1: "Rete Italia is Australia's national Italian-language radio network, created to connect Italian communities across the country through news, culture, music, and conversation.",
    story2: "Rete Italia began broadcasting in 1994, launching first in New South Wales with services in Sydney, Gosford, and Wollongong. From the very beginning, the vision was clear: to create a strong, professional Italian-language service that reflected the voice, experiences, and interests of Italian Australians.",
    story3: "Soon after its NSW launch, Rete Italia expanded to Melbourne, recognising the importance of serving Australia's largest Italian community. This marked the start of the network's growth into a truly national service.",
    story4: "Over time, Rete Italia continued to expand, establishing frequencies in all Australian capital cities and in major regional centres where large Italian communities live and work. This national reach has allowed Italian Australians, no matter where they are, to stay connected through a shared language and culture.",
    programmingTitle: "Rete Italia's programming covers:",
    prog1: "Italian and Australian news and current affairs",
    prog2: "Talkback and community discussion",
    prog3: "Sport, with a strong focus on football",
    prog4: "Music from Italy and the Italian diaspora",
    prog5: "Cultural, religious, and community programming",
    story5: "As generations have changed, Rete Italia has evolved with its audience — continuing to serve first-generation migrants while also engaging younger listeners who balance Italian heritage with contemporary Australian life.",
    story6: "Today, Rete Italia remains a trusted voice for Italian Australians, bringing communities together through radio and digital platforms, and continuing its mission to inform, entertain, and connect Italians across Australia.",
    yearsOfPassion: "Years of Passion",
    passionTitle: "Passion",
    passionDesc: "We love what we do and we do it with all our heart",
    communityTitle: "Community",
    communityDesc: "We unite people through culture and music",
    connectionTitle: "Connection",
    connectionDesc: "A bridge between Italy and Australia",
    qualityTitle: "Quality",
    qualityDesc: "Excellent content for our listeners",
    teamTitle: "Our Team",
    teamDesc: "A team of passionate professionals, dedicated to bringing the best of Italian culture to Australia every single day.",
    djsTitle: "DJs & Presenters",
    djsDesc: "Professional voices that bring our programs to life",
    techTitle: "Technical Team",
    techDesc: "Experts ensuring 24/7 quality streaming",
    editorialTitle: "Editorial",
    editorialDesc: "Journalists and content creators for always fresh content"
  },
  
  // Schedule Page
  schedule: {
    title: "Schedule",
    subtitle: "Discover our daily programs. Music, information and entertainment all day long.",
    todayPrograms: "Programs of",
    with: "With",
    note: "Important Note",
    noteText: "The schedule may change. Stay tuned to Rete Italia for real-time updates!",
    loading: "Loading..."
  },
  
  // Podcast Page
  podcast: {
    title: "Podcasts",
    subtitle: "Listen to our podcasts whenever you want, wherever you want. Exclusive content always available.",
    episodes: "episodes",
    weekly: "Weekly",
    listen: "Listen",
    ctaTitle: "Don't Miss Any Episode",
    ctaSubtitle: "Subscribe to our newsletter to receive notifications about new podcasts",
    subscribeNow: "Subscribe Now",
    loading: "Loading..."
  },
  
  // Contact Page
  contact: {
    title: "Contact Us",
    subtitle: "We're here to listen. Send us a message or contact us through our social channels.",
    sendMessage: "Send a Message",
    fullName: "Full Name",
    fullNamePlaceholder: "Your name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    subject: "Subject",
    subjectPlaceholder: "Message subject",
    message: "Message",
    messagePlaceholder: "Write your message here...",
    sendButton: "Send Message",
    sending: "Sending...",
    contactInfo: "Contact Information",
    emailLabel: "Email",
    emailAddress: "info@reteitalia.com.au",
    phoneLabel: "Phone",
    phoneNumber: "1300 363 900",
    phoneHours: "For live calls",
    addressLabel: "Studio",
    melbourneStudio: "Melbourne Studio",
    melbourneAddress: "35-37 Melville Road, Brunswick West VIC 3055 Australia",
    sydneyStudio: "Sydney Studio",
    sydneyAddress: "194-196 Norton St, Leichhardt NSW 2040 Australia",
    followUs: "Follow Us on Social",
    followUsDesc: "Stay connected with us through our social channels for updates, news and exclusive content.",
    messageSent: "Message Sent!",
    messageSuccess: "We will reply as soon as possible.",
    messageError: "Error",
    messageErrorDesc: "An error occurred. Please try again later."
  },
  
  // Footer
  footer: {
    description: "Your Italian radio in Australia. Music, culture and information 24/7.",
    quickLinks: "Quick Links",
    contact: "Contact",
    followUs: "Follow Us",
    allRightsReserved: "All rights reserved"
  },
  
  // Common
  common: {
    live: "LIVE",
    offline: "OFFLINE",
    inDirect: "ON AIR",
    loading: "Loading advertisement..."
  }
};
